{
  "v2.organisation.a_venir": "screen coming later",
  "v2.organisation.annuler": "Cancel",
  "v2.organisation.appartenance.ajouter_programme": "Add to the programme",
  "v2.organisation.appartenance.ajouter_projet": "Add to the project",
  "v2.organisation.appartenance.deja_membre": "Already a member: edit the membership from the record.",
  "v2.organisation.appartenance.echec": "The membership was not saved.",
  "v2.organisation.appartenance.enregistree": "Membership saved.",
  "v2.organisation.appartenance.heritage_programme": "A profile set on a programme applies to its projects, unless a more restricted profile is set on a project.",
  "v2.organisation.appartenance.heritage_projet": "A more restricted profile set on a project prevails over the programme one; a descending administration profile is never overridden.",
  "v2.organisation.appartenance.modifier": "Save the change",
  "v2.organisation.appartenance.profils_illisibles": "Current profiles could not be read: nothing can be edited.",
  "v2.organisation.appartenance.profils_programme": "Profiles on the programme",
  "v2.organisation.appartenance.profils_projet": "Profiles on the project",
  "v2.organisation.appartenance.titre": "Add or edit a membership",
  "v2.organisation.appartenance.type": "Type",
  "v2.organisation.aucun_profil": "No profile",
  "v2.organisation.choisir": "Choose…",
  "v2.organisation.code.ALREADY_MEMBER": "The person is already a member of this space.",
  "v2.organisation.code.ANNUAIRE_TROP_VOLUMINEUX": "Too many rows: narrow the filters.",
  "v2.organisation.code.ATTESTATION_REQUISE": "The attestation is required.",
  "v2.organisation.code.ATTRIBUTION_REFUSEE": "An assignment was refused: nothing was sent.",
  "v2.organisation.code.COMPTE_DESACTIVE": "The account is deactivated.",
  "v2.organisation.code.CONFLIT_CONCURRENT": "The record changed in the meantime: it was reloaded, check and save again.",
  "v2.organisation.code.CORPS_HISTORIQUE_RETIRE": "Request refused: withdrawn format.",
  "v2.organisation.code.CREATEUR_N_APPROUVE_PAS": "The requester cannot approve their own request.",
  "v2.organisation.code.DEACTIVATION_REASON_REQUIRED": "The reason is required.",
  "v2.organisation.code.DEMANDE_DEJA_DECIDEE": "This request has already been decided.",
  "v2.organisation.code.DEMANDE_DEJA_MEMBRE": "This person is already a member.",
  "v2.organisation.code.DEMANDE_EN_DOUBLE": "A request is already pending for this address.",
  "v2.organisation.code.DROIT_HORS_NIVEAU": "This right is not of this level.",
  "v2.organisation.code.DROIT_ISOLE_INTROUVABLE": "Isolated right not found.",
  "v2.organisation.code.DROIT_NON_TENU": "You do not hold the required right.",
  "v2.organisation.code.DROIT_PERSONNEL_NON_ACCORDABLE": "A personal right cannot be granted.",
  "v2.organisation.code.DROIT_RESERVE_AU_PROPRIETAIRE": "This right is reserved to the owner.",
  "v2.organisation.code.ECHEANCE_PASSEE": "The date must be in the future.",
  "v2.organisation.code.EMAIL_NOT_SENT": "The email was not sent.",
  "v2.organisation.code.INVITATION_EMAIL_ALREADY_EXISTS": "This address already belongs to a member or a pending invitation.",
  "v2.organisation.code.INVITATION_EMAIL_DOMAIN_NOT_ALLOWED": "The domain of this address is not allowed.",
  "v2.organisation.code.INVITATION_EMAIL_INVALID": "Invalid address.",
  "v2.organisation.code.INVITATION_NOT_RENEWABLE": "This invitation can no longer be renewed.",
  "v2.organisation.code.INVITATION_NOT_REVOCABLE": "This invitation is already accepted or revoked.",
  "v2.organisation.code.INVITATION_NOT_VALID": "This invitation is no longer valid.",
  "v2.organisation.code.INVITATION_RATE_LIMITED": "Too many invitations sent: try again later.",
  "v2.organisation.code.KEYCLOAK_UNAVAILABLE": "The sign-in directory is unreachable: nothing was changed.",
  "v2.organisation.code.LAST_ORG_ADMIN": "Nobody could administer the organisation any more.",
  "v2.organisation.code.MEMBERSHIP_NOT_FOUND": "Membership not found.",
  "v2.organisation.code.MOTIF_TROP_COURT": "The reason is too short.",
  "v2.organisation.code.OWNERSHIP_TRANSFER_REQUIRED": "Some ownerships still need a new owner.",
  "v2.organisation.code.PERSONNE_NON_MEMBRE": "The person is not a member of this space.",
  "v2.organisation.code.PROFIL_INCONNU": "Unknown profile.",
  "v2.organisation.code.PROFIL_NIVEAU_INCOMPATIBLE": "This profile is not of this level.",
  "v2.organisation.code.PROGRAM_MEMBER_EXISTS": "The person is already a member of the programme.",
  "v2.organisation.code.PROPRIETAIRE_ORGANISATION_NON_DESACTIVABLE": "The organisation owner cannot be deactivated.",
  "v2.organisation.code.REACTIVATION_REASON_REQUIRED": "The reason is required.",
  "v2.organisation.code.RECUPERATION_PAR_LA_PLATEFORME": "Only the platform recovers the organisation owner’s access.",
  "v2.organisation.code.RESTAURATION_HORS_DELAI": "Period over: memberships must be reassigned.",
  "v2.organisation.code.SELF_ACCESS_RESET_FORBIDDEN": "You cannot reset your own access here.",
  "v2.organisation.code.SELF_DEACTIVATION_FORBIDDEN": "You cannot deactivate your own account.",
  "v2.organisation.code.SELF_ROLE_CHANGE_FORBIDDEN": "You cannot change your own profiles.",
  "v2.organisation.code.TRANSFER_TARGET_INVALID": "The new owner must be an active member of the space.",
  "v2.organisation.code.USER_ALREADY_DEACTIVATED": "The account is already deactivated.",
  "v2.organisation.code.USER_DEACTIVATED": "The account is deactivated.",
  "v2.organisation.code.USER_NOT_DEACTIVATED": "This account is not deactivated.",
  "v2.organisation.code.USER_NOT_FOUND": "Member not found.",
  "v2.organisation.code.WORKSPACE_ARCHIVED": "This project is archived: read only.",
  "v2.organisation.demandes.adresse": "Email address of the person",
  "v2.organisation.demandes.adresse_requise": "Enter the person’s address.",
  "v2.organisation.demandes.approuvee": "Request approved: invitation created.",
  "v2.organisation.demandes.approuver": "Approve",
  "v2.organisation.demandes.approuver_de": "Approve the request for {{email}}",
  "v2.organisation.demandes.approuver_echec": "The request was not approved.",
  "v2.organisation.demandes.col_date": "Requested on",
  "v2.organisation.demandes.col_demandeur": "Requester",
  "v2.organisation.demandes.col_motif": "Reason",
  "v2.organisation.demandes.demander": "Request an invitation",
  "v2.organisation.demandes.echec": "The request was not sent.",
  "v2.organisation.demandes.envoyee": "Request sent.",
  "v2.organisation.demandes.envoyer": "Send the request",
  "v2.organisation.demandes.refusee": "Request refused.",
  "v2.organisation.demandes.refuser": "Refuse",
  "v2.organisation.demandes.refuser_de": "Refuse the request for {{email}}",
  "v2.organisation.demandes.refuser_echec": "The request was not refused.",
  "v2.organisation.demandes.refuser_effet": "The requester is notified of the refusal.",
  "v2.organisation.demandes.refuser_titre": "Refuse the request for {{email}}?",
  "v2.organisation.demandes.titre": "Invitation requests",
  "v2.organisation.demandes.vide": "No pending request.",
  "v2.organisation.desactiver.ajout_echec": "The new owner was not added.",
  "v2.organisation.desactiver.ajouter_programme": "Add {{nom}} to the programme",
  "v2.organisation.desactiver.ajouter_projet": "Add {{nom}} to the project",
  "v2.organisation.desactiver.attestation": "I attest that this person is leaving the organisation and that the takeovers are decided.",
  "v2.organisation.desactiver.aucun_candidat": "No other active member: first add a new owner to the organisation.",
  "v2.organisation.desactiver.aucune_cle": "No key or webhook to take over.",
  "v2.organisation.desactiver.aucune_reprise": "No ownership to take over.",
  "v2.organisation.desactiver.bouton": "Deactivate the account",
  "v2.organisation.desactiver.cles_revoquees": "The person’s keys and webhooks will be revoked.",
  "v2.organisation.desactiver.consequence_appartenances": "Project and programme memberships are removed (restorable within the period).",
  "v2.organisation.desactiver.consequence_connexion": "Sign-in is blocked.",
  "v2.organisation.desactiver.consequence_historique": "The history is kept.",
  "v2.organisation.desactiver.consequence_sessions": "Open sessions are closed.",
  "v2.organisation.desactiver.echec": "The account was not deactivated.",
  "v2.organisation.desactiver.fait": "Account deactivated.",
  "v2.organisation.desactiver.membres_espace": "members of {{nom}}",
  "v2.organisation.desactiver.repreneur": "New owner of {{nom}}",
  "v2.organisation.desactiver.repreneur_manquant": "Choose a new owner.",
  "v2.organisation.desactiver.reprises": "Ownerships to take over",
  "v2.organisation.desactiver.titre": "Deactivate the account of a person who is leaving",
  "v2.organisation.droit_isole.accorde": "Isolated right granted.",
  "v2.organisation.droit_isole.accorder": "Grant the right",
  "v2.organisation.droit_isole.accorder_programme": "Grant on the chosen programme",
  "v2.organisation.droit_isole.accorder_projet": "Grant on the chosen project",
  "v2.organisation.droit_isole.case_prerequis": "Also grant the read prerequisites",
  "v2.organisation.droit_isole.case_publier": "Also grant the right to publish",
  "v2.organisation.droit_isole.catalogue_erreur": "The rights catalogue could not be read.",
  "v2.organisation.droit_isole.choisir_droit": "Choose a right",
  "v2.organisation.droit_isole.date": "End date (optional)",
  "v2.organisation.droit_isole.date_future": "The date must be in the future.",
  "v2.organisation.droit_isole.deja_tenu": "Already held through a profile: this isolated right is useless.",
  "v2.organisation.droit_isole.droit": "Right",
  "v2.organisation.droit_isole.ecart": "This right will be shown as a deviation in the organisation administration; separation of duties still prevails.",
  "v2.organisation.droit_isole.echec": "The right was not granted.",
  "v2.organisation.droit_isole.inutilisable": "Without them, the right will remain unusable.",
  "v2.organisation.droit_isole.l_organisation": "The organisation",
  "v2.organisation.droit_isole.objet": "Target",
  "v2.organisation.droit_isole.prerequis": "Read prerequisites: {{liste}}",
  "v2.organisation.droit_isole.prerequis_aucun": "No missing read prerequisite.",
  "v2.organisation.droit_isole.prolonger": "Already granted as an isolated right: the end date will be extended.",
  "v2.organisation.droit_isole.titre": "Grant an isolated right to a person",
  "v2.organisation.droit_isole.un_programme": "A programme",
  "v2.organisation.droit_isole.un_projet": "A project",
  "v2.organisation.empeche.deja_desactive": "The account is already deactivated.",
  "v2.organisation.empeche.desactive": "The account is deactivated.",
  "v2.organisation.empeche.pas_desactive": "This account is not deactivated.",
  "v2.organisation.empeche.proprietaire_acces": "The organisation owner can only be recovered by the platform.",
  "v2.organisation.empeche.proprietaire_depart": "The organisation owner can only leave after transferring ownership.",
  "v2.organisation.empeche.vous": "This is your own account.",
  "v2.organisation.enregistrer": "Save",
  "v2.organisation.etat.chargement": "Loading: {{quoi}}…",
  "v2.organisation.etat.en_cours": "In progress…",
  "v2.organisation.etat.erreur": "Could not load: {{quoi}}.",
  "v2.organisation.etat.introuvable": "{{quoi}} not found.",
  "v2.organisation.etat.reessayer": "Retry",
  "v2.organisation.etat.refus": "Access denied: {{quoi}}.",
  "v2.organisation.fermer": "Close",
  "v2.organisation.fiche.acces_et_depart": "Access and departure",
  "v2.organisation.fiche.accorder": "Grant an isolated right",
  "v2.organisation.fiche.actions_requises": "Required actions: {{liste}}",
  "v2.organisation.fiche.ajouter_appartenance": "Add a membership",
  "v2.organisation.fiche.annuaire_injoignable": "Sign-in directory unreachable: account state unknown.",
  "v2.organisation.fiche.appartenance": "{{nom}} ({{niveau}})",
  "v2.organisation.fiche.appartenances": "Memberships",
  "v2.organisation.fiche.attribuer": "Assign a profile",
  "v2.organisation.fiche.aucun_droit": "No effective right.",
  "v2.organisation.fiche.aucun_historique": "No event.",
  "v2.organisation.fiche.aucun_isole": "No isolated right.",
  "v2.organisation.fiche.aucun_profil_pose": "No organisation profile set.",
  "v2.organisation.fiche.aucune_appartenance": "No project or programme membership.",
  "v2.organisation.fiche.aucune_delegation": "No delegation.",
  "v2.organisation.fiche.aucune_invitation": "No invitation or link.",
  "v2.organisation.fiche.avec_delegation": "Also holds rights through a received delegation.",
  "v2.organisation.fiche.compte": "Sign-in account",
  "v2.organisation.fiche.connexion_autorisee": "Sign-in allowed",
  "v2.organisation.fiche.connexion_bloquee": "Sign-in blocked",
  "v2.organisation.fiche.deconnectee": "Sessions closed: the person is signed out everywhere.",
  "v2.organisation.fiche.deconnecter": "Force sign-out",
  "v2.organisation.fiche.deconnecter_echec": "Sessions were not closed.",
  "v2.organisation.fiche.deconnecter_effet": "The person is signed out everywhere; earlier tokens are refused.",
  "v2.organisation.fiche.deconnecter_titre": "Force {{nom}} to sign out?",
  "v2.organisation.fiche.delegation_donnees": "Delegation given, until {{fin}}",
  "v2.organisation.fiche.delegation_recues": "Delegation received, until {{fin}}",
  "v2.organisation.fiche.delegations": "Delegations",
  "v2.organisation.fiche.dernier_acces": "Last access: {{date}}",
  "v2.organisation.fiche.dernier_proprietaire": "last active owner",
  "v2.organisation.fiche.droits": "Effective rights",
  "v2.organisation.fiche.droits_sur": "{{objet}}: {{n}} effective rights ({{profils}})",
  "v2.organisation.fiche.historique": "Member history",
  "v2.organisation.fiche.identifiant": "Technical identifier",
  "v2.organisation.fiche.invitation_ligne": "{{statut}} — {{date}}",
  "v2.organisation.fiche.invitations": "Invitations and links",
  "v2.organisation.fiche.isole_echec": "The isolated right was not removed.",
  "v2.organisation.fiche.isole_ligne": "{{droit}} — on {{objet}}, {{fin}}",
  "v2.organisation.fiche.isole_retire": "Isolated right removed.",
  "v2.organisation.fiche.isoles": "Isolated rights",
  "v2.organisation.fiche.isoles_signales": "{{n}} isolated right(s)",
  "v2.organisation.fiche.libelle": "Member record",
  "v2.organisation.fiche.modifier_appartenance": "Edit the membership of {{nom}}",
  "v2.organisation.fiche.otp_a_configurer": "Second factor to configure",
  "v2.organisation.fiche.otp_configure": "Second factor configured",
  "v2.organisation.fiche.otp_non_configure": "Second factor not configured",
  "v2.organisation.fiche.par_propriete": "Administered through ownership.",
  "v2.organisation.fiche.phrase": "{{date}} — {{acteur}}: {{action}}",
  "v2.organisation.fiche.profil_origine": "{{profil}} (set on: {{origine}})",
  "v2.organisation.fiche.profils": "Profiles and rights",
  "v2.organisation.fiche.reinitialiser": "Reset access",
  "v2.organisation.fiche.restreint": "restricted by {{liste}}",
  "v2.organisation.fiche.retirer_isole": "Remove the isolated right {{droit}}",
  "v2.organisation.fiche.retirer_isole_effet": "The right stops immediately; it stays in the history.",
  "v2.organisation.fiche.retirer_isole_titre": "Remove the isolated right “{{droit}}”?",
  "v2.organisation.fiche.retour": "Back to members",
  "v2.organisation.fiche.sans_fin": "no end date",
  "v2.organisation.fiche.titre": "Member record",
  "v2.organisation.fiche.tout_le_journal": "Full log",
  "v2.organisation.fiche.transferer": "Transfer ownership to this member",
  "v2.organisation.fiche.voir_profil": "View the profile",
  "v2.organisation.fiche.vous": "this is you",
  "v2.organisation.invitation.statut.accepted": "Accepted",
  "v2.organisation.invitation.statut.expired": "Expired",
  "v2.organisation.invitation.statut.pending": "Pending",
  "v2.organisation.invitation.statut.revoked": "Revoked",
  "v2.organisation.invitations.col_actions": "Actions",
  "v2.organisation.invitations.col_adresse": "Address",
  "v2.organisation.invitations.col_expire": "Expires on",
  "v2.organisation.invitations.col_statut": "Status",
  "v2.organisation.invitations.filtre": "Invitation status",
  "v2.organisation.invitations.inviter": "Invite a person",
  "v2.organisation.invitations.lien_pour": "New link for {{email}}: pass it on yourself.",
  "v2.organisation.invitations.renouvelee": "Invitation renewed: new link, the old one is revoked.",
  "v2.organisation.invitations.renouveler": "Renew",
  "v2.organisation.invitations.renouveler_de": "Renew the invitation of {{email}}",
  "v2.organisation.invitations.renouveler_echec": "The invitation was not renewed.",
  "v2.organisation.invitations.revoquee": "Invitation revoked.",
  "v2.organisation.invitations.revoquer": "Revoke",
  "v2.organisation.invitations.revoquer_de": "Revoke the invitation of {{email}}",
  "v2.organisation.invitations.revoquer_echec": "The invitation was not revoked.",
  "v2.organisation.invitations.revoquer_effet": "The link stops working; a never-activated account is deleted.",
  "v2.organisation.invitations.revoquer_titre": "Revoke the invitation of {{email}}?",
  "v2.organisation.invitations.sans_courriel": "Installation without email sending: you will pass the link on yourself.",
  "v2.organisation.invitations.titre": "Invitations",
  "v2.organisation.invitations.toutes": "All",
  "v2.organisation.invitations.vide": "No invitation.",
  "v2.organisation.inviter.adresse": "Email address",
  "v2.organisation.inviter.adresse_invalide": "Invalid address.",
  "v2.organisation.inviter.ajouter_attribution": "Add the assignment",
  "v2.organisation.inviter.attribution": "{{espace}} — {{profil}}",
  "v2.organisation.inviter.attributions": "Assignments on projects and programmes",
  "v2.organisation.inviter.aucune_attribution": "No assignment.",
  "v2.organisation.inviter.avertissement_admin": "This profile grants administration of the whole organisation.",
  "v2.organisation.inviter.bouton": "Invite",
  "v2.organisation.inviter.courriel_non_parti": "The email was not sent: copy the link and pass it on yourself.",
  "v2.organisation.inviter.doublon": "Duplicate submission ignored: the invitation already exists.",
  "v2.organisation.inviter.echec": "The invitation was not sent.",
  "v2.organisation.inviter.espace": "Assignment space",
  "v2.organisation.inviter.espaces": "projects and programmes",
  "v2.organisation.inviter.membre_simple": "None (plain member)",
  "v2.organisation.inviter.nom": "Last name",
  "v2.organisation.inviter.prenom": "First name",
  "v2.organisation.inviter.profil_organisation": "Organisation profile",
  "v2.organisation.inviter.profil_programme": "Profile on the programme",
  "v2.organisation.inviter.profil_projet": "Profile on the project",
  "v2.organisation.inviter.renvoi_echec": "The email was not resent.",
  "v2.organisation.inviter.renvoi_non_parti": "The email still was not sent.",
  "v2.organisation.inviter.renvoye": "Email resent.",
  "v2.organisation.inviter.renvoyer": "Resend the email",
  "v2.organisation.inviter.retirer_attribution": "Remove the assignment on {{espace}}",
  "v2.organisation.inviter.titre": "Invite a person to the organisation",
  "v2.organisation.inviter.validite": "Link validity",
  "v2.organisation.inviter.validite_168": "7 days",
  "v2.organisation.inviter.validite_24": "24 hours",
  "v2.organisation.inviter.validite_72": "3 days",
  "v2.organisation.jamais": "Never",
  "v2.organisation.lien.copie": "Link copied.",
  "v2.organisation.lien.copier": "Copy the link",
  "v2.organisation.lien.une_fois": "Link to pass on yourself: it is shown only once.",
  "v2.organisation.membres.aucun_profil": "No organisation profile",
  "v2.organisation.membres.aucun_resultat": "No member matches the filters.",
  "v2.organisation.membres.col_acces": "Last access",
  "v2.organisation.membres.col_espaces": "Projects and programmes",
  "v2.organisation.membres.col_nom": "Name",
  "v2.organisation.membres.col_profils": "Profiles set",
  "v2.organisation.membres.col_proprietaire": "Owner",
  "v2.organisation.membres.col_second": "Second factor",
  "v2.organisation.membres.col_statut": "Status",
  "v2.organisation.membres.compte_actifs": "Active: {{n}}",
  "v2.organisation.membres.compte_admins": "Administrators: {{n}}",
  "v2.organisation.membres.compte_desactives": "Deactivated: {{n}}",
  "v2.organisation.membres.compte_invites": "Invited: {{n}}",
  "v2.organisation.membres.compteurs_chargement": "Loading counters…",
  "v2.organisation.membres.compteurs_erreur": "Counters unavailable.",
  "v2.organisation.membres.effacer": "Clear filters",
  "v2.organisation.membres.espaces": "{{projets}} project(s), {{programmes}} programme(s)",
  "v2.organisation.membres.export_echec": "The directory was not exported.",
  "v2.organisation.membres.export_filtres": "According to the applied filters.",
  "v2.organisation.membres.exporte": "Directory exported (written to the log).",
  "v2.organisation.membres.exporter": "Export the directory",
  "v2.organisation.membres.filtre_espace": "Project or programme",
  "v2.organisation.membres.filtre_profil": "Profile",
  "v2.organisation.membres.filtre_second": "Second factor",
  "v2.organisation.membres.filtre_statut": "Status",
  "v2.organisation.membres.lecture_seule": "Read only: you do not manage members.",
  "v2.organisation.membres.libelle": "Directory",
  "v2.organisation.membres.libelle_table": "Members",
  "v2.organisation.membres.onglet_membres": "Members",
  "v2.organisation.membres.onglet_profils": "Profiles",
  "v2.organisation.membres.onglet_revue": "Refusal review",
  "v2.organisation.membres.onglet_securite": "Sign-in security",
  "v2.organisation.membres.onglets": "Member sections",
  "v2.organisation.membres.page": "{{de}} to {{a}} of {{total}}",
  "v2.organisation.membres.precedente": "Previous page",
  "v2.organisation.membres.proprietaire": "Owner",
  "v2.organisation.membres.rechercher": "Search",
  "v2.organisation.membres.second_a_configurer": "To configure",
  "v2.organisation.membres.second_configure": "Configured",
  "v2.organisation.membres.second_non_configure": "Not configured",
  "v2.organisation.membres.statut_active": "Active",
  "v2.organisation.membres.statut_deactivated": "Deactivated",
  "v2.organisation.membres.statut_invited": "Invited",
  "v2.organisation.membres.suivante": "Next page",
  "v2.organisation.membres.titre": "Organisation members",
  "v2.organisation.membres.vide": "No member.",
  "v2.organisation.modifier": "Edit",
  "v2.organisation.motif": "Reason",
  "v2.organisation.motif_facultatif": "Reason (optional)",
  "v2.organisation.motif_min": "At least {{n}} characters.",
  "v2.organisation.niveau.organisation": "organisation",
  "v2.organisation.niveau.programme": "programme",
  "v2.organisation.niveau.projet": "project",
  "v2.organisation.niveau_titre.programme": "Programme",
  "v2.organisation.niveau_titre.projet": "Project",
  "v2.organisation.pour": "Person concerned: {{nom}}",
  "v2.organisation.profils.champ": "Organisation profiles (can be combined)",
  "v2.organisation.profils.dernier_admin": "Removal refused: nobody could administer the organisation any more.",
  "v2.organisation.profils.echec": "The profiles were not saved.",
  "v2.organisation.profils.enregistres": "Organisation profiles saved.",
  "v2.organisation.profils.membre_simple": "No profile ticked: plain member, with no organisation right.",
  "v2.organisation.profils.pour": "Organisation profiles of {{nom}}",
  "v2.organisation.profils.titre": "Assign or remove an organisation profile",
  "v2.organisation.reactiver.au_dela": "Period over: nothing will be restored, memberships must be reassigned.",
  "v2.organisation.reactiver.aucune": "No removed membership to restore.",
  "v2.organisation.reactiver.bouton": "Reactivate the account",
  "v2.organisation.reactiver.echec": "The account was not reactivated.",
  "v2.organisation.reactiver.effet_appartenances": "Removed memberships only come back if you restore them within the period.",
  "v2.organisation.reactiver.effet_connexion": "The person will be able to sign in again.",
  "v2.organisation.reactiver.fait": "Account reactivated.",
  "v2.organisation.reactiver.item": "{{nom}} ({{niveau}}): {{profils}}",
  "v2.organisation.reactiver.restaurer": "Restore the removed memberships (period until {{date}})",
  "v2.organisation.reactiver.retirees": "Removed memberships",
  "v2.organisation.reactiver.titre": "Reactivate a deactivated account",
  "v2.organisation.reinit.bouton": "Reset access",
  "v2.organisation.reinit.courriel": "An email was sent to the person.",
  "v2.organisation.reinit.echec": "Access was not reset.",
  "v2.organisation.reinit.effet_journal": "The person is notified and the action is written to the log.",
  "v2.organisation.reinit.effet_lien": "A single-use link, valid for 24 hours, lets the person choose a new password.",
  "v2.organisation.reinit.effet_mot_de_passe": "The current password remains valid until the link is used.",
  "v2.organisation.reinit.effet_sessions": "Open sessions are closed when the link is used.",
  "v2.organisation.reinit.otp": "Also reset the second factor",
  "v2.organisation.reinit.otp_effet": "The second factor is deleted now and must be configured again.",
  "v2.organisation.reinit.titre": "Reset a member’s access",
  "v2.organisation.retirer": "Remove",
  "v2.organisation.sans_organisation": "Your account belongs to no organisation.",
  "v2.organisation.simulation.aucun": "No right changes.",
  "v2.organisation.simulation.calcul": "Computing the rights that change…",
  "v2.organisation.simulation.erreur": "The rights that change could not be computed.",
  "v2.organisation.simulation.gagnes": "Rights gained:",
  "v2.organisation.simulation.perdus": "Rights lost:",
  "v2.organisation.simulation.titre": "Rights that change",
  "v2.organisation.statut.actif": "Active",
  "v2.organisation.statut.desactive_le": "Deactivated on {{date}}",
  "v2.organisation.statut.invite": "Invited, activation pending",
  "v2.organisation.tous": "All",
  "v2.organisation.voir": "View"
}
